import { provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { Environment } from 'projects/shared/src/lib/core/interfaces/environment';
import { ENVIRONMENT_TOKEN } from 'projects/shared/src/lib/core/injection-tokens/environment.token';
import { CommonHttpInterceptor } from 'projects/shared/src/lib/infrastructure/interceptors/common-http.interceptor';
import { provideAuth, withAppInitializerAuthCheck } from 'angular-auth-oidc-client';
import { openIdConfigurationFactory } from 'projects/shared/src/lib/infrastructure/auth/auth-config';
import { provideTranslateService } from '@ngx-translate/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { AtrPreset } from '../assets/atr-theme';
import { NormTestFlowAdapter } from './infrastructure/adapters/norm-test-flow.adapter';
import { EXERCISE_FLOW_ADAPTER_TOKEN } from 'projects/shared/src/lib/core/injection-tokens/exercise-flow-adapter.token';
import { TTS_ENABLED } from 'projects/shared/src/lib/core/services/speech.service';

export const appConfig = (environment: Environment) => ({
  providers: [
    NormTestFlowAdapter,
    { provide: TTS_ENABLED, useValue: false },
    { provide: ENVIRONMENT_TOKEN, useValue: environment },
    { provide: EXERCISE_FLOW_ADAPTER_TOKEN, useExisting: NormTestFlowAdapter },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CommonHttpInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes, withViewTransitions()),
    provideZonelessChangeDetection(),
    provideAuth(
      {
        config: openIdConfigurationFactory(environment),
      },
      withAppInitializerAuthCheck()
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        failOnError: true,
        resources: [
          { prefix: 'assets/i18n/', suffix: '.json' },
          { prefix: 'assets/i18n/tasks-content/', suffix: '.json' },
        ],
      }),
    }),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: { preset: AtrPreset, options: { darkModeSelector: '.app-dark' } },
    }),
  ],
});
